const KnowledgeCenterIcon = () => {
  return (
    <svg
      width='80'
      height='60'
      viewBox='0 0 80 60'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M79.9997 0H28.8008V4.07114C37.6228 6.93564 44.0005 15.223 44.0005 25C44.0005 34.777 37.6228 43.0644 28.8008 45.9289V60H79.9997V0Z'
        fill='#E4E9FF'
      />
      <path
        d='M43.9138 26.9717C43.9714 26.3223 44.001 25.6641 44.001 25C44.001 23.6357 43.876 22.2959 43.6382 21H72.001V27H43.9114C43.9121 26.9902 43.9131 26.9814 43.9138 26.9717Z'
        fill='#CDD6FF'
      />
      <path
        d='M42.5012 33C41.646 35.1885 40.4485 37.2119 38.9773 38.9941C38.9756 38.9961 38.9741 38.998 38.9724 39H68.001V33H42.5012Z'
        fill='#CDD6FF'
      />
      <path
        d='M41.6021 15H72.001V10H38.0945C39.4783 11.4844 40.6604 13.1611 41.5942 14.9844C41.5969 14.9893 41.5994 14.9951 41.6021 15Z'
        fill='#CDD6FF'
      />
      <path d='M38.001 44H58.001V50H38.001V44Z' fill='#CDD6FF' />
      <path
        d='M20.5846 39.25V42.4167H17.418V39.25H4.7513C4.33138 39.25 3.92865 39.0832 3.63172 38.7863C3.33478 38.4893 3.16797 38.0866 3.16797 37.6667V12.3333C3.16797 11.9134 3.33478 11.5107 3.63172 11.2138C3.92865 10.9168 4.33138 10.75 4.7513 10.75H14.2513C15.15 10.7489 16.0385 10.9396 16.8577 11.3093C17.6768 11.679 18.4076 12.2192 19.0013 12.8938C19.595 12.2192 20.3258 11.679 21.1449 11.3093C21.9641 10.9396 22.8526 10.7489 23.7513 10.75H33.2513C33.6712 10.75 34.074 10.9168 34.3709 11.2138C34.6678 11.5107 34.8346 11.9134 34.8346 12.3333V37.6667C34.8346 38.0866 34.6678 38.4893 34.3709 38.7863C34.074 39.0832 33.6712 39.25 33.2513 39.25H20.5846ZM31.668 36.0833V13.9167H23.7513C22.9114 13.9167 22.106 14.2503 21.5121 14.8442C20.9183 15.438 20.5846 16.2435 20.5846 17.0833V36.0833H31.668ZM17.418 36.0833V17.0833C17.418 16.2435 17.0843 15.438 16.4905 14.8442C15.8966 14.2503 15.0912 13.9167 14.2513 13.9167H6.33464V36.0833H17.418Z'
        fill='#0000C9'
      />
    </svg>
  );
};

export default KnowledgeCenterIcon;
